import { GUI } from "dat.gui";

const _instance = new GUI()
export default _instance